export const isPapel = (product) =>
  product.category === "Kaplama" &&
  (product.subcategory === "Papel Kaplama" || (!product.subcategory &&
    (product.cut === "Papel" || /\bpapel\b/i.test(product.name || ""))));

// The card summary comes from the saved description, not a thickness facet.
export const papelCardDescription = (product, lang) => {
  if (!isPapel(product)) return "";
  const description = lang === "en" && product.description_en
    ? product.description_en : product.description;
  const line = (description || "").split("\n").find((value) =>
    /^[\s•*\-]*(Kalınlık|Thickness)\s*:/i.test(value)
  );
  return line ? line.replace(/^[\s•*\-]+/, "").trim() : "";
};